require('../../modules/es.array.find');

module.exports = require('../../internals/entry-unbind')('Array', 'find');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/es/array/find.js
// module id = 234
// module chunks = 1